import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { ContentComponent } from './components/content/content.component';
import { NavigationItemComponent } from './components/navigation-item/navigation-item.component';
import { TogglerViewTypeComponent } from './components/toggler-view-type/toggler-view-type.component';

@NgModule({
  declarations: [ContentComponent, NavigationItemComponent, TogglerViewTypeComponent],
  imports: [CommonModule, TranslateModule, RouterModule],
  exports: [ContentComponent, NavigationItemComponent, TogglerViewTypeComponent],
})
export class CoreLayoutModule {}
